import React, { forwardRef, memo } from 'react'

const ChatIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="36.4"
      height="36.4"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 52 52"
      fill="none"
      {...props}>
      <path
        d="M26 28.4376C27.3462 28.4376 28.4375 27.3463 28.4375 26.0001C28.4375 24.6539 27.3462 23.5626 26 23.5626C24.6538 23.5626 23.5625 24.6539 23.5625 26.0001C23.5625 27.3463 24.6538 28.4376 26 28.4376Z"
        fill="#78BE20"
      />
      <path
        d="M17.0625 28.4376C18.4087 28.4376 19.5 27.3463 19.5 26.0001C19.5 24.6539 18.4087 23.5626 17.0625 23.5626C15.7163 23.5626 14.625 24.6539 14.625 26.0001C14.625 27.3463 15.7163 28.4376 17.0625 28.4376Z"
        fill="#78BE20"
      />
      <path
        d="M34.9375 28.4376C36.2837 28.4376 37.375 27.3463 37.375 26.0001C37.375 24.6539 36.2837 23.5626 34.9375 23.5626C33.5913 23.5626 32.5 24.6539 32.5 26.0001C32.5 27.3463 33.5913 28.4376 34.9375 28.4376Z"
        fill="#78BE20"
      />
      <path
        d="M16.2359 42.8817C20.332 45.2523 25.1504 46.0524 29.7928 45.1328C34.4353 44.2132 38.5848 41.6366 41.4678 37.8835C44.3509 34.1304 45.7706 29.4568 45.4623 24.7343C45.154 20.0117 43.1388 15.5624 39.7923 12.2159C36.4458 8.86942 31.9965 6.85418 27.2739 6.54589C22.5513 6.23761 17.8778 7.65733 14.1247 10.5404C10.3716 13.4234 7.795 17.5729 6.87539 22.2154C5.95577 26.8578 6.75587 31.6762 9.12651 35.7723L6.58542 43.359C6.48993 43.6453 6.47607 43.9526 6.5454 44.2463C6.61472 44.5401 6.76449 44.8087 6.97791 45.0222C7.19132 45.2356 7.45996 45.3853 7.75372 45.4547C8.04747 45.524 8.35472 45.5101 8.64104 45.4146L16.2359 42.8817Z"
        stroke="#78BE20"
        strokeWidth="3.22689"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
)

ChatIcon.displayName = 'ChatIcon'

export default memo(ChatIcon)
